/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExcelDocumentTypeEnum as OkEgisServiceModelsDtoEnumsExcelDocumentTypeEnum } from '../models/OK/Egis/Service/Models/DTO/Enums/excel-document-type-enum';
import { ExcelDocumentCreateRequestDto as OkEgisServiceModelsDtoExcelDocumentCreateRequestDto } from '../models/OK/Egis/Service/Models/DTO/excel-document-create-request-dto';
import { ExcelDocumentCreateResponseDto as OkEgisServiceModelsDtoExcelDocumentCreateResponseDto } from '../models/OK/Egis/Service/Models/DTO/excel-document-create-response-dto';
import { ExcelDocumentUploadResponseDto as OkEgisServiceModelsDtoExcelDocumentUploadResponseDto } from '../models/OK/Egis/Service/Models/DTO/excel-document-upload-response-dto';

@Injectable({
  providedIn: 'root',
})
export class ExcelService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createDocument
   */
  static readonly CreateDocumentPath = '/api/v1/Excel/CreateDocument';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDocument$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoExcelDocumentCreateRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentCreateResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.CreateDocumentPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentCreateResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDocument(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoExcelDocumentCreateRequestDto
  }): Observable<OkEgisServiceModelsDtoExcelDocumentCreateResponseDto> {

    return this.createDocument$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentCreateResponseDto>) => r.body as OkEgisServiceModelsDtoExcelDocumentCreateResponseDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDocument$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createDocument$FormData$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoExcelDocumentCreateRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentCreateResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.CreateDocumentPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentCreateResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createDocument$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createDocument$FormData(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoExcelDocumentCreateRequestDto
  }): Observable<OkEgisServiceModelsDtoExcelDocumentCreateResponseDto> {

    return this.createDocument$FormData$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentCreateResponseDto>) => r.body as OkEgisServiceModelsDtoExcelDocumentCreateResponseDto)
    );
  }

  /**
   * Path part for operation downloadDocument
   */
  static readonly DownloadDocumentPath = '/api/v1/Excel/DownloadDocument/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadDocument$Response(params: {
    documentId: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.DownloadDocumentPath, 'get');
    if (params) {
      rb.path('documentId', params.documentId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `downloadDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadDocument(params: {
    documentId: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.downloadDocument$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation uploadDocument
   */
  static readonly UploadDocumentPath = '/api/v1/Excel/UploadDocument';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadDocument$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: {
'Document'?: Blob;
'DocumentType'?: OkEgisServiceModelsDtoEnumsExcelDocumentTypeEnum;
'Id'?: number;
'ValidateOnly'?: boolean;
}
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentUploadResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.UploadDocumentPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentUploadResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadDocument(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: {
'Document'?: Blob;
'DocumentType'?: OkEgisServiceModelsDtoEnumsExcelDocumentTypeEnum;
'Id'?: number;
'ValidateOnly'?: boolean;
}
  }): Observable<OkEgisServiceModelsDtoExcelDocumentUploadResponseDto> {

    return this.uploadDocument$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentUploadResponseDto>) => r.body as OkEgisServiceModelsDtoExcelDocumentUploadResponseDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadDocument$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadDocument$FormData$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: {
'Document'?: Blob;
'DocumentType'?: OkEgisServiceModelsDtoEnumsExcelDocumentTypeEnum;
'Id'?: number;
'ValidateOnly'?: boolean;
}
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentUploadResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.UploadDocumentPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentUploadResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadDocument$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadDocument$FormData(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: {
'Document'?: Blob;
'DocumentType'?: OkEgisServiceModelsDtoEnumsExcelDocumentTypeEnum;
'Id'?: number;
'ValidateOnly'?: boolean;
}
  }): Observable<OkEgisServiceModelsDtoExcelDocumentUploadResponseDto> {

    return this.uploadDocument$FormData$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoExcelDocumentUploadResponseDto>) => r.body as OkEgisServiceModelsDtoExcelDocumentUploadResponseDto)
    );
  }

}
